<template>
    <div>
        <div class="normalheader ">
            <div class="hpanel">
                <div class="panel-body">
                    <div id="hbreadcrumb" class="pull-right m-t-lg">
                        <ol class="hbreadcrumb breadcrumb">
                            <li>
                                <router-link tag="a" :to="{name:'dashboard'}">Portada</router-link>
                            </li>
                            <li class="active">
                                <span>Perfil</span>
                            </li>
                        </ol>
                    </div>
                    <h2 class="font-light m-b-xs">
                        Perfil
                    </h2>
                    <small>Actualizar mi perfil</small>
                </div>
            </div>

        </div>
        <div class="content">
            <div class="hpanel hviolet">
                <div class="panel-heading hbuilt">
                    Perfil
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-lg-3 text-center">
                            <i class="pe-7s-user fa-5x text-muted"></i>
                            <p class="m-t-md">
                                <strong>{{name}}</strong>
                            </p>
                        </div>
                        <div class="col-md-9">
                            <div class="row">
                                <div class="col-md-4 form-group">
                                    <label>Nombre</label>
                                    <custom-input tipo="text" :field="$v.form.name"/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Correo electrónico</label>
                                    <custom-input tipo="text" :field="$v.form.email"/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Celular</label>
                                    <custom-input tipo="text" :field="$v.form.phone"/>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4 form-group">
                                    <label>Contraseña actual</label>
                                    <custom-input tipo="password" :field="$v.form.oldPassword"
                                                  placeholder="***********"/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Nueva contraseña</label>
                                    <custom-input tipo="password" :field="$v.form.newPassword"
                                                  placeholder="***********"/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Repite nueva contraseña</label>
                                    <custom-input tipo="password" :field="$v.form.repeatNewPassword"
                                                  placeholder="***********"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-right">
                        <a class="btn btn-primary" @click="save">Guardar</a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

    import {PROFILE} from "../../router/routes";
    import CustomInput from '../common/CustomInput.vue'
    import {alphaNum, email, maxLength, required, sameAs} from 'vuelidate/lib/validators'
    import ProfileService from '../../services/ProfileService';
    import Alert from "../../util/alert";
    import {USER_REQUEST} from "../../store/actions/user";

    export default {
        name: PROFILE.name,
        components: {CustomInput},
        data: () => ({
            name: null,
            form: {
                name: null,
                email: null,
                phone: null,
                oldPassword: null,
                newPassword: null,
                repeatNewPassword: null,
            }
        }),
        validations: {
            form: {
                name: {required, maxLength: maxLength(100)},
                email: {required, maxLength: maxLength(45), email},
                phone: {required, maxLength: maxLength(45)},
                oldPassword: {},
                newPassword: {alphaNum},
                repeatNewPassword: {sameAsPassword: sameAs('newPassword')},
            }
        },
        methods: {
            async init() {
                const self = this;
                self.hotels = [];
                try {
                    const profile = (await ProfileService.getProfile()).data.payload;
                    self.load(profile);
                } catch (err) {
                    Alert.mensajeError(err.message);
                }
            },
            load(profile) {
                const self = this;
                self.name = profile.name;
                self.form.name = profile.name;
                self.form.email = profile.email;
                self.form.phone = profile.phone;
            },
            async save() {
                this.$v.$touch();
                if (this.$v.$error) return;
                const self = this;

                const data = {...self.form};
                try {
                    const profileUpdated = (await ProfileService.updateProfile(data)).data.payload;
                    self.load(profileUpdated);
                    Alert.mensajeExito("Perfil actualizado.");
                    self.$store.dispatch(USER_REQUEST);
                    self.form.oldPassword = self.form.newPassword = self.form.repeatNewPassword = null;
                    self.$v.$reset();
                } catch (err) {
                    Alert.mensajeError(err.message);
                }
            },
            clear() {
                const self = this;
                self.form.name = self.form.email = null;
                self.form.phone = '';
            }
        }
        ,
        mounted() {
            this.init();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/profile/Profile.vue